"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.status.active': 'Aktywny',
    'settings.status.inactive': 'Nieaktywny',
    'settings.status.enabled': 'Włączony',
    'settings.status.disabled': 'Wyłączony',
    'settings.status.connected': 'Połączony',
    'settings.status.notConnected': 'Nie połączony',
    'settings.status.authenticated': 'Uwierzytelniony',
    'settings.status.notAuthenticated': 'Nieuwierzytelniony',
};
